module.exports = __webpack_public_path__ + "static/media/Himpunan Mahasiswa Jurnalistik UNPAD.ca328d68.jpeg";